import React from 'react';
import { useProject } from '../../../hooks/useNotionProjects';
import MovieProject from './ProjectTypes/MovieProject';
import WebProject from './ProjectTypes/WebProject';
import MobileProject from './ProjectTypes/MobileProject';
import DefaultProject from './ProjectTypes/DefaultProject';
import './ProjectDetail.css';

interface ProjectDetailProps {
  projectId: string;
}

const ProjectDetail: React.FC<ProjectDetailProps> = ({ projectId }) => {
  const { project, loading, error } = useProject(projectId);

  // ローディング表示
  if (loading) {
    return (
      <div className="project-detail">
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          color: '#ffffff',
          fontFamily: 'Azeret Mono',
          fontSize: '14px',
          letterSpacing: '1px',
          gap: '20px'
        }}>
          <div>Loading project...</div>
        </div>
      </div>
    );
  }

  // エラー表示
  if (error) {
    return (
      <div className="project-detail">
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          color: '#ffffff',
          fontFamily: 'Azeret Mono',
          fontSize: '14px',
          letterSpacing: '1px'
        }}>
          <div>Failed to load project</div>
        </div>
      </div>
    );
  }

  // プロジェクトが見つからない場合
  if (!project) {
    return (
      <div className="project-detail">
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          color: '#ffffff',
          fontFamily: 'Azeret Mono',
          fontSize: '14px',
          letterSpacing: '1px'
        }}>
          <div>Project not found</div>
        </div>
      </div>
    );
  }

  // プロジェクトタイプに応じてコンポーネントを選択
  const renderProjectByType = () => {
    switch (project.category) {
      case 'movie':
        return <MovieProject project={project} />;
      case 'web':
        return <WebProject project={project} />;
      case 'mobile':
        return <MobileProject project={project} />;
      default:
        return <DefaultProject project={project} />;
    }
  };

  return renderProjectByType();
};

export default ProjectDetail;
